export default __webpack_public_path__ + "images/arrow_forward_ios_black_24dp.svg";